import React, { useEffect, useState } from 'react';
import Badge from 'react-bootstrap/Badge';

const BetslipFloatingButton = ({ betCount, onClick, isDarkMode }) => {
  const [shouldBounce, setShouldBounce] = useState(false);

  // Trigger bounce animation when betCount changes
  useEffect(() => {
    if (betCount > 0) {
      setShouldBounce(true);
      const timer = setTimeout(() => setShouldBounce(false), 500);
      return () => clearTimeout(timer);
    }
  }, [betCount]);

  // Don't show if no bets
  if (betCount === 0) {
    return null;
  }

  return (
    <div
      onClick={onClick}
      className={shouldBounce ? 'betslip-button-bounce' : ''}
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        backgroundColor: isDarkMode ? '#0d6efd' : '#0d6efd',
        color: '#fff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
        // Sit above player modal + backdrop + odds-detail bottom sheet
        // (highest of those is 1210) so nothing can intercept the tap zone.
        // Toast at 3000 still wins for the 2s it appears.
        zIndex: 1220,
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        userSelect: 'none'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'scale(1.1)';
        e.currentTarget.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.4)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.3)';
      }}
    >
      {/* Ticket Icon */}
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ marginBottom: '2px' }}
      >
        <path
          d="M4 4h16v4.5c-1.1 0-2 .9-2 2s.9 2 2 2V20H4v-7.5c1.1 0 2-.9 2-2s-.9-2-2-2V4z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M10 4v16M14 4v16"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>

      {/* Count Badge */}
      <Badge
        bg="danger"
        pill
        style={{
          position: 'absolute',
          top: '-5px',
          right: '-5px',
          fontSize: '0.7rem',
          minWidth: '22px',
          height: '22px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 'bold'
        }}
      >
        {betCount}
      </Badge>
    </div>
  );
};

export default BetslipFloatingButton;
